export const useQueryParameters = () => {
  const search = new URLSearchParams(window.location.search);
  return Array.from(search.values());
};
